<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>订单管理</span>
        </div>
        <el-form :inline="true">
          <el-form-item label="日期" prop="startDate">
            <el-date-picker
              v-model="queryParams.date"
              value-format="yyyy-MM-dd"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            />
          </el-form-item>
          <!--          <el-form-item label="开始日期" prop="startDate">-->
          <!--            <el-date-picker-->
          <!--              v-model="queryParams.startDate"-->
          <!--              type="date"-->
          <!--              style="width: 150px"-->
          <!--              placeholder="选择日期"-->
          <!--              value-format="yyyy-MM-dd"-->
          <!--              @keyup.enter.native="handleQuery"-->
          <!--            />-->
          <!--          </el-form-item>-->
          <!--          <el-form-item label="结束日期" prop="endDate">-->
          <!--            <el-date-picker-->
          <!--              v-model="queryParams.endDate"-->
          <!--              style="width: 150px"-->
          <!--              type="date"-->
          <!--              placeholder="选择日期"-->
          <!--              value-format="yyyy-MM-dd"-->
          <!--              @keyup.enter.native="handleQuery"-->
          <!--            />-->
          <!--          </el-form-item>-->
          <el-form-item label="用户UID">
            <el-input
              v-model.number="queryParams.uid"
              style="width: 120px"
              placeholder="UID"
              clearable
              size="small"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
          <el-form-item label="用户等级">
            <el-input
              v-model.number="queryParams.level"
              style="width: 120px"
              placeholder="用户等级"
              clearable
              size="small"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
          <el-form-item label="订单号">
            <el-input
              v-model="queryParams.externalOrderId"
              placeholder="请输入订单号"
              clearable
              size="small"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model.number="queryParams.status" style="width: 150px" placeholder="状态" clearable size="small">
              <el-option
                v-for="dict in statusOptions"
                :key="dict.value"
                :label="dict.label"
                :value="dict.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="平台">
            <el-select v-model.number="queryParams.sid" style="width: 150px" placeholder="平台" clearable size="small">
              <el-option
                v-for="dict in sidOptions"
                :key="dict.value"
                :label="dict.label"
                :value="dict.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="版本">
            <el-select v-model="queryParams.version" filterable style="width: 150px" placeholder="版本" clearable size="small">
              <el-option
                v-for="dict in versionArr"
                :key="dict.value"
                :label="dict.label"
                :value="dict.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="商品">
            <el-select v-model.number="queryParams.gtype" filterable style="width: 150px" placeholder="商品" clearable size="small">
              <el-option
                v-for="(item,id) in gtype"
                :key="parseInt(id)"
                :label="item"
                :value="parseInt(id)"
              />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" size="mini" :loading="loading" @click="handleQuery">查询</el-button>
            <el-button v-permisaction="['config:order:export']" :loading="loading" type="primary" icon="el-icon-search" size="mini" @click="handleExport">导出</el-button>
          </el-form-item>
        </el-form>
        <el-table
          :data="tableData"
          border
          style="width: 100%;"
          :cell-class-name="delLine"
        >
          <el-table-column
            fixed
            prop="externalOrderId"
            label="订单ID"
            align="center"
            width="200px"
          />
          <el-table-column
            prop="uid"
            label="UID"
            align="center"
            width="120"
          >
            <template v-slot:default="props">
              <a style="color: #0e6cff;text-decoration:underline;text-underline: #1c84c6;margin-right: 10px;" href="javascript:;" @click="gotoinfo(props.row.uid)">{{ props.row.uid }}</a>
            </template>
          </el-table-column>
          <el-table-column
            prop="createTime"
            label="注册时间"
            align="center"
            width="200px"
          />
          <el-table-column
            prop="lastTime"
            label="登录时间"
            align="center"
            width="200px"
          />
          <el-table-column
            prop="level"
            label="等级"
            align="center"
          />
          <el-table-column
            prop="country"
            label="国家"
            align="center"
          />
          <el-table-column
            prop="sid"
            label="平台"
            align="center"
            :formatter="sidFormatter"
          />
          <el-table-column
            label="商品"
            prop="gid"
            align="center"
            width="200px"
          >
            <template v-slot:default="props">
              <span v-if="props.row.title === ''"> props.row.gif</span>
              <span v-else> {{ props.row.title }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="price"
            label="商品价格"
            align="center"
          >
            <template v-slot:default="props">
              <span v-if="props.row.price == 0.01">$0(苹果试用)</span>
              <span v-else>${{ props.row.price }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="isFirst"
            label="首次支付"
            align="center"
          >
            <template v-slot:default="props">
              <span v-if="props.row.isFirst">是</span>
              <span v-else>否</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="status"
            label="订单状态"
            align="center"
          >
            <template v-slot:default="props">
              <el-tag v-if="props.row.status === -2" type="info">已失效</el-tag>
              <el-tag v-if="props.row.status === -1" type="info">已取消</el-tag>
              <el-tag v-if="props.row.status === 0" type="danger">待支付</el-tag>
              <el-tag v-if="props.row.status === 1" type="danger">待验证</el-tag>
              <el-tag v-if="props.row.status === 2" type="warning">待发货</el-tag>
              <el-tag v-if="props.row.status === 3" type="info">已退款</el-tag>
              <el-tag v-if="props.row.status === 4">已发货</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            prop="createdAt"
            label="创建时间"
            align="center"
            width="200px"
          />
          <el-table-column
            prop="updatedAt"
            label="更新时间"
            align="center"
            width="200px"
          />
          <el-table-column
            prop="purchasedAt"
            label="支付时间"
            align="center"
            width="200px"
          />
          <el-table-column
            prop="version"
            label="版本"
            width="120px"
            align="center"
          />
          <el-table-column
            prop="reward"
            label="奖励"
            :formatter="rewardFormatter"
            width="220px"
            align="center"
          />
          <el-table-column
            prop="externalVer"
            label="续费次数"
            width="120px"
            align="center"
          >
            <template v-slot:default="{row}">
              <span v-if="row.gid === 801">{{ row.externalVer }}</span>
              <span v-else>-</span>
            </template>

          </el-table-column>
          <!--          <el-table-column-->
          <!--            prop="right"-->
          <!--            label="操作"-->
          <!--          >-->
          <!--            <template v-slot:default="scope">-->
          <!--              <el-button v-permisaction="['config:sysMail:edit']" type="text" size="small" @click="edit(scope.row.id)">编辑</el-button>-->
          <!--              &lt;!&ndash;              <el-button type="text" size="small">编辑</el-button>&ndash;&gt;-->
          <!--            </template>-->
          <!--          </el-table-column>-->
        </el-table>
        <pagination
          v-show="total>0"
          background
          :page.sync="queryParams.pageIndex"
          :limit.sync="queryParams.pageSize"
          :total="total"
          @pagination="getTables"
        />
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { exportOrder, getOrderList } from '@/api/config/order'
import { getRewardType } from '@/api/config/slot'
import { getCacheQuery, getLastDates, setCacheQuery } from '@/utils'
import { getCommonCfg } from '@/api/config/common-cfg'
export default {
  name: 'Order',
  data() {
    return {
      loading: false,
      queryParams: {
        pageIndex: 1,
        pageSize: 10,
        startDate: '',
        endDate: '',
        date: [],
        externalOrderId: '',
        status: 4,
        uid: '',
        level: '',
        sid: '',
        gtype: '',
        version: ''
      },
      statusOptions: [
        { label: '已失效', value: -2 },
        { label: '已取消', value: -1 },
        { label: '待支付', value: 0 },
        { label: '待验证', value: 1 },
        { label: '待发货', value: 2 },
        { label: '已退款', value: 3 },
        { label: '已发货', value: 4 }
      ],
      gtype: [],
      total: 0,
      rewardType: [],
      tableData: [],
      versionArr: [],
      sidOptions: [
        { label: '所有', value: 0 },
        { label: '安卓', value: 1 },
        { label: '苹果', value: 2 }
      ]
    }
  },
  created() {
    if (!this.queryParams.date[0]) {
      this.queryParams.date[0] = getLastDates(0)
      this.queryParams.date[1] = getLastDates(0)
    }
    const gtype = this.$route.query.gtype
    if (gtype) {
      this.queryParams.gtype = parseInt(gtype)
    }
    this.getVersion()
    this.getRewardTypeData()
    this.getTables(undefined)
  },
  methods: {
    handleQuery() {
      if (!this.queryParams.date || this.queryParams.date.length <= 0) {
        this.msgError('请选择日期')
        return
      }

      this.queryParams.startDate = this.queryParams.date[0]
      this.queryParams.endDate = this.queryParams.date[1]
      if (!this.queryParams.startDate) {
        this.msgError('请选择开始日期')
        return
      }

      if (!this.queryParams.endDate) {
        this.msgError('请选择结束日期')
        return
      }

      if (this.queryParams.startDate > this.queryParams.endDate) {
        this.msgError('开始日期不能大于结束日期')
        return
      }

      // this.$store.dispatch('queryForm/orderForm', { value: this.queryParams })
      // this.queryParams.pageIndex = 1
      // this.queryParams.pageSize = 10
      this.getTables({})
    },
    getRewardTypeData() {
      getRewardType().then(res => {
        if (res.code === 200) {
          this.rewardType = res.data
        }
      })
    },
    getTables(event) {
      this.loading = true
      this.queryParams = getCacheQuery(this.$options.name, this.queryParams, event)
      getOrderList(this.queryParams).then(res => {
        setCacheQuery(this.$options.name, this.queryParams)
        this.loading = false
        if (res.code === 200) {
          this.tableData = res.data.list.list
          this.total = res.data.count
          this.gtype = res.data.list.gtype
          this.queryParams.date[0] = res.data.list.req.StartDate
          this.queryParams.date[1] = res.data.list.req.EndDate
        } else {
          this.msgError(res.msg)
        }
      })
    },
    sidFormatter(row, column) {
      if (row.sid === 1) {
        return '安卓'
      }

      return '苹果'
    },
    rewardFormatter(row, column) {
      const str = []
      if (row.reward) {
        row.reward.forEach(item => {
          for (const i in this.rewardType) {
            const val = this.rewardType[i]
            if (parseInt(i) === parseInt(item.propsId)) {
              str.push(val + ' * ' + item.num)
            }
          }
        })
      }

      return str.join(',')
    },
    handleExport() {
      this.queryParams.startDate = this.queryParams.date[0]
      this.queryParams.endDate = this.queryParams.date[1]
      if (!this.queryParams.startDate) {
        this.msgError('请选择开始时间')
        return
      }
      if (!this.queryParams.endDate) {
        this.msgError('请选择结束时间')
        return
      }
      if (this.queryParams.startDate > this.queryParams.endDate) {
        this.msgError('开始时间不能大于结束时间')
        return
      }
      this.loading = true
      exportOrder(this.queryParams).then(res => {
        this.loading = false
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          setTimeout(() => {
            this.$router.push({ path: '/config/export-file/index' })
          }, 500)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    delLine({ row, rowIndex }) {
      if (row.isWhite) return 'del_line'
    },
    gotoinfo(uid) {
      const url = this.$router.resolve({ name: 'User', query: {
        uid: uid
      }}).href
      window.open(url, '_blank')
    },
    getVersion() {
      getCommonCfg({ name: 'StaticVersion' }).then(res => {
        if (res.code === 200) {
          res.data.forEach(item => {
            this.versionArr.unshift({ label: item, value: item })
          })
        } else {
          this.msgError(res.msg)
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
